import React from "react";
import DimensionPointMarker from "./DimensionPointMarker";
import DimensionLine3D from "./DimensionLine3D";

export default function DimensionRenderer3D({
  pickedPoints = [],
  savedDimensions = [],
  selectedDimensionId = null,
  dimensionMode = "free",
  markerSize = 1.5,
  dimensionOffset = 15,
  workPlane = { plane: "xy", offset: 0 },
  onSelectDimension,
}) {
  return (
    <group>
      {pickedPoints.map((point, index) => (
        <DimensionPointMarker
          key={`picked_${index}`}
          point={point}
          index={index}
          markerSize={markerSize}
        />
      ))}

      {savedDimensions.map((dimension) => (
        <DimensionLine3D
  key={dimension.id}
  dimension={dimension}
  mode={dimension.mode || "free"}
  markerSize={markerSize}
  defaultOffset={dimensionOffset}
  workPlane={workPlane}
  selected={String(selectedDimensionId) === String(dimension.id)}
  onSelect={onSelectDimension}
/>
      ))}

      {pickedPoints.length >= 2 ? (
        <DimensionLine3D
  points={pickedPoints}
  mode={dimensionMode}
  markerSize={markerSize}
  defaultOffset={dimensionOffset}
  workPlane={workPlane}
  selected={false}
/>
      ) : null}
    </group>
  );
}